import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { TimerComponent, sendInterval } from '../../components/Timer';
import styled from 'styled-components';
import LoginController from '../../controller/LoginController';

interface LoginUserJoinFormProps {
  setUserJoinSuccess: React.Dispatch<React.SetStateAction<boolean>>;
  userId: string;
  userPw: string;
  userPwCheck: string;
  ceoName: string;
  storeName: string;
  businessNumber: string;
  userEmailFront: string;
  userEmailBack: string;
  userPhoneNumber: string;
  email: string;
  partnersId: string;
  setUserId: (userId: string) => void;
  setUserPw: (userPw: string) => void;
  setUserPwCheck: (userPwCheck: string) => void;
  setCeoName: (ceoName: string) => void;
  setStoreName: (storeName: string) => void;
  setBusinessNumber: (businessNumber: string) => void;
  setUserEmailFront: (userEmailFront: string) => void;
  setUserEmailBack: (userEmailBack: string) => void;
  setUserPhoneNumber: (userPhoneNumber: string) => void;
  setPartnersId: (partnersId: string) => void;
}

let timer: any = null;

export const LoginUserJoinForm = ({
  setUserJoinSuccess,
  userId,
  userPw,
  userPwCheck,
  ceoName,
  storeName,
  businessNumber,
  userEmailFront,
  userEmailBack,
  userPhoneNumber,
  email,
  partnersId,
  setUserId,
  setUserPw,
  setUserPwCheck,
  setCeoName,
  setStoreName,
  setBusinessNumber,
  setUserEmailFront,
  setUserEmailBack,
  setUserPhoneNumber,
  setPartnersId,
}: LoginUserJoinFormProps) => {
  const navigate = useNavigate();
  const [sendMessage, setSendMessage] = React.useState<boolean>(false);

  const [userIdErrorText, setUserIdErrorText] = React.useState<string>('');
  const [userPwErrorText, setUserPwErrorText] = React.useState<string>('');
  const [salesErrorText, setSalesErrorText] = React.useState<string>('');
  const [ceoNameErrorText, setCeoNameErrorText] = React.useState<string>('');
  const [userEmailErrorText, setUserEmailErrorText] = React.useState<string>('');
  const [storeNameErrorText, setStoreNameErrorText] = React.useState<string>('');
  const [businessNumberErrorText, setBusinessNumberErrorText] = React.useState<string>('');
  const [userPhoneErrorText, setUserPhoneErrorText] = React.useState<string>('');
  const [countdown, setCountdown] = React.useState<number>(0);
  const [authenticationKey, setAuthenticationKey] = React.useState<number>(0);
  const [timerRunning, setTimerRunning] = React.useState<boolean>(false);

  const regExp = /[0-9 \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\\(\=]/gi;

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const numericValue = value.replace(/\D/g, '');

    if (event.target.id === 'userId') {
      setUserId(value);

      if (userId !== '') {
        setUserIdErrorText('');
      }
    } else if (event.target.id === 'userPw') {
      setUserPw(value);
    } else if (event.target.id === 'userPwCheck') {
      setUserPwCheck(value);
      if (userPw !== '' && userPwCheck !== '') {
        setUserPwErrorText('');
      }
    } else if (event.target.id === 'ceoName') {
      setCeoName(value);
      if (regExp.test(value)) {
        setCeoNameErrorText('올바른 이름을 입력해 주세요.');
      } else {
        setCeoNameErrorText('');
      }
    } else if (event.target.id === 'storeName') {
      setStoreName(value);
      if (storeName !== '') {
        setStoreNameErrorText('');
      }
    } else if (event.target.id === 'businessNumber') {
      setBusinessNumber(numericValue);
      if (businessNumber !== '') {
        setBusinessNumberErrorText('');
      }
    } else if (event.target.id === 'userEmailFront') {
      setUserEmailFront(value);
      if (userEmailFront !== '') {
        setUserEmailErrorText('');
      }
    } else if (event.target.id === 'userEmailBack') {
      setUserEmailBack(value);
      if (userEmailBack !== '') {
        setUserEmailErrorText('');
      }
    } else if (event.target.id === 'userPhoneNumber') {
      setUserPhoneNumber(numericValue);
      if (numericValue.length > 11) {
        setUserPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
      } else {
        setUserPhoneErrorText('');
      }
    } else if (event.target.id === 'partnersId') {
      setPartnersId(value);
    }
  };

  // 인증번호 받기
  const sendSignUp = () => {
    const pattern = /[가-힣]*[ㄱ-ㅎㅏ-ㅣ]+[가-힣]*/;
    const regExp = /[0-9 \{\}\[\]\/?.,;:|\)*~`!^\-_+┼<>@\#$%&\'\"\\\(\=]/gi;
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
    const idRegex = /^[A-Za-z0-9]*$/;
    let isValid = true;

    if (userId.length < 4) {
      setUserIdErrorText('아이디를 4글자 이상 입력해 주세요.');
      isValid = false;
    }
    if (!idRegex.test(userId)) {
      setUserIdErrorText('아이디에 한글은 사용할 수 없습니다.');
    }
    if (userId.length > 30) {
      setUserIdErrorText('아이디는 30자 이하로 입력해주세요.');
    }
    if (userPw.length < 4) {
      setUserPwErrorText('비밀번호를 4글자 이상 입력해 주세요.');
      isValid = false;
    }
    if (userPw === '' || userPwCheck === '') {
      setUserPwErrorText('올바른 비밀번호를 입력해 주세요.');
      isValid = false;
    }
    if (userPw !== userPwCheck) {
      setUserPwErrorText('비밀번호가 일치하지 않습니다.');
      isValid = false;
    }
    if (ceoName === '' || pattern.test(ceoName) || regExp.test(ceoName)) {
      setCeoNameErrorText('올바른 이름을 입력해 주세요.');
      isValid = false;
    }
    if (storeName === '') {
      setStoreNameErrorText('올바른 매장명을 입력해 주세요.');
      isValid = false;
    }
    if (businessNumber === '') {
      setBusinessNumberErrorText('올바른 사업자번호를 입력해 주세요.');
      isValid = false;
    }
    if (!emailRegex.test(email)) {
      setUserEmailErrorText('올바른 이메일 주소를 입력해 주세요.');
      isValid = false;
    }
    if (userPhoneNumber === '' || userPhoneNumber.length < 10 || userPhoneNumber.length > 11) {
      setUserPhoneErrorText('올바른 휴대폰 번호를 입력해주세요.');
      isValid = false;
    }

    if (isValid) {
      singUpApi();
    }
  };

  // api_회원가입
  const singUpApi = async () => {
    let oData: any = {
      id: userId,
      password: userPwCheck,
      full_name: ceoName,
      business_name: storeName,
      business_number: businessNumber,
      email: email,
      phone_number: userPhoneNumber,
      sales_login_id: partnersId !== '' ? partnersId : '',
    };

    try {
      const oResp = await LoginController.signUp(oData);
      let oResponse = oResp?.data;

      if (oResponse.ok === true && oResponse !== undefined) {
        setUserJoinSuccess(true);
      } else if (oResponse.errors[0].status === 409) {
        setUserIdErrorText('중복된 아이디입니다.');
      } else if (oResponse.errors[0].status === 404) {
        setSalesErrorText('영업사 ID가 올바르지않습니다.');
      } else if (oResponse.errors[0].status === 403) {
        setBusinessNumberErrorText(oResponse.msg);
        console.log('oResponse.errors[0].msg', oResponse.msg);
      }
    } catch (err) {
      console.log('err-->', err);
    }
  };

  return (
    <Style>
      <div className="FormWrap">
        <div className="FormContent">
          <div>
            <div className="loginForm">
              <label htmlFor="userId">아이디</label>
              <input
                type="text"
                id="userId"
                value={userId}
                onChange={handleInputChange}
                placeholder="아이디를 입력해 주세요."
                style={{ border: userIdErrorText !== '' ? '1px solid #FDA29B' : '' }}
              />
              <p className="errorMessage">{userIdErrorText}</p>
            </div>
            <div className="loginForm">
              <label htmlFor="userPw">비밀번호</label>
              <input
                type="password"
                id="userPw"
                value={userPw}
                onChange={handleInputChange}
                placeholder="비밀번호를 입력해 주세요."
                style={{ border: userPwErrorText !== '' ? '1px solid #FDA29B' : '' }}
              />
              <input
                type="password"
                id="userPwCheck"
                value={userPwCheck}
                onChange={handleInputChange}
                placeholder="비밀번호를 한번 더 입력해 주세요."
                className="checkInput"
                style={{ border: userPwErrorText !== '' ? '1px solid #FDA29B' : '' }}
              />
              <p className="errorMessage">{userPwErrorText}</p>
            </div>
            <div className="loginForm">
              <label htmlFor="ceoName">대표자명</label>
              <input
                type="text"
                id="ceoName"
                value={ceoName}
                onChange={handleInputChange}
                placeholder="매장 대표자명을 입력해 주세요."
                style={{ border: ceoNameErrorText !== '' ? '1px solid #FDA29B' : '' }}
              />
              <p className="errorMessage">{ceoNameErrorText}</p>
            </div>
            <div className="loginForm">
              <label htmlFor="storeName">사업자명</label>
              <input
                type="text"
                id="storeName"
                value={storeName}
                onChange={handleInputChange}
                placeholder="사업자등록증 기준 매장명을 입력해 주세요."
                style={{ border: storeNameErrorText !== '' ? '1px solid #FDA29B' : '' }}
              />
              <p className="errorMessage">{storeNameErrorText}</p>
              <input
                type="text"
                id="businessNumber"
                value={businessNumber}
                onChange={handleInputChange}
                inputMode="numeric"
                pattern="[0-9]*"
                placeholder="-없이 사업자 등록번호를 입력해 주세요."
                style={{ border: businessNumberErrorText !== '' ? '1px solid #FDA29B' : '' }}
              />
              <p className="errorMessage">{businessNumberErrorText}</p>
            </div>
            <div className="loginForm">
              <label htmlFor="userEmailFront">Email</label>
              <div className="emailWrap">
                <input
                  type="text"
                  id="userEmailFront"
                  value={userEmailFront}
                  onChange={handleInputChange}
                  placeholder="이메일 앞자리"
                  style={{ border: userEmailErrorText !== '' ? '1px solid #FDA29B' : '' }}
                />
                <p>@</p>
                <input
                  type="text"
                  id="userEmailBack"
                  value={userEmailBack}
                  onChange={handleInputChange}
                  placeholder="이메일 뒷자리"
                  style={{ border: userEmailErrorText !== '' ? '1px solid #FDA29B' : '' }}
                />
              </div>
              <p className="errorMessage">{userEmailErrorText}</p>
            </div>
            <div className="loginForm">
              <label htmlFor="userPhoneNumber">휴대폰 번호</label>
              <input
                type="text"
                id="userPhoneNumber"
                inputMode="numeric"
                pattern="[0-9]*"
                value={userPhoneNumber}
                onChange={handleInputChange}
                placeholder="‘ - ‘ 하이픈 없이 휴대폰 번호를 입력해주세요"
                style={{ border: userPhoneErrorText !== '' ? '1px solid #FDA29B' : '' }}
              />
              <p className="errorMessage">{userPhoneErrorText}</p>
            </div>
            <div className="lineWrap">
              <div className="line"></div>
              <p>선택 입력</p>
              <div className="line"></div>
            </div>
            <div className="loginForm">
              <label htmlFor="userPhoneNumber">영업사 (영업사 직원만 입력)</label>
              <input
                type="text"
                id="partnersId"
                value={partnersId}
                onChange={handleInputChange}
                placeholder="영업사 아이디를 입력해주세요."
                style={{ border: salesErrorText !== '' ? '1px solid #FDA29B' : '' }}
              />
              <p className="errorMessage">{salesErrorText}</p>
            </div>
            <button className="authenticationNumber" onClick={sendSignUp}>
              <p>회원가입하기</p>
            </button>
          </div>
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  /* 이메일 */
  .emailWrap {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;

    input {
      width: 45%;
    }
  }

  /* 인증번호받기,확인 버튼 */
  .authenticationNumber,
  .checkAuthenticationNumber {
    width: 100%;
    padding: 12px 0;
    margin: 32px 0;
    background: #fff;
    border-radius: 8px;
    border: 1px solid #72727e;
    outline: none;

    p {
      font-size: 18px;
      font-weight: 600;
      color: #26282c;
    }
  }
  .checkAuthenticationNumber {
    background: #26282c;
    border: none;

    p {
      color: #ffffff;
    }
  }

  /* 인증번호 */
  .authenticationForm {
    position: relative;

    .timer {
      position: absolute;
      top: 40%;
      right: 12px;

      p {
        margin: 0;
        font-size: 12px;
        font-weight: 500;
        color: #f04438;
      }
    }
    input {
      margin-top: 0;
    }
  }
  .noticeMessage {
    width: 100%;
    margin: 12px 0 6px 0;
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #4f5459;

    button {
      font-weight: 600;
      text-decoration: underline;
      text-underline-offset: 4px;
      background: none;
      outline: none;
      border: none;
      color: #4f5459;
      font-size: 14px;
      font-weight: 600;
    }
  }
  .checkInput {
    margin-top: 6px;
  }
  .lineWrap {
    margin-top: 20px;
    display: flex;
    align-items: center;
    gap: 10px;
    .line {
      flex: 1;
      background: #d0d5dd;
      height: 1px;
    }
    p {
      font-size: 12px;
      color: #777;
    }
  }

  @media (max-width: 800px) {
    .wrap {
      max-height: calc(var(--vh, 1vh) * 100);
      background: #fff;
    }
    .container {
      width: 100%;
      max-width: 100%;
      padding: 20px !important;
    }
    .title {
      margin-top: 32px;
      margin-bottom: 20px;
    }
    .loginFind {
      button {
        margin-left: 8px;

        p {
          font-size: 12px;
        }
      }
    }
    .footer {
      p {
        font-size: 12px;
      }
    }
  }
`;
